// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"_1iQ07ssXvQzLggGCgvZb4_","langChangerWrapper":"VD2XvR-VVVbBeKhbNkQOl","menuWrapper":"_4Uj4YmB8dfBqfqKi4Aapv"};